import { SIMAElementClassifier, SIMARouteType, } from "@earthbrain/sima";
import { getNextRouteCoord, getPrevRouteCoord, interpolateSimpleCurve, } from "./route-utils";
export class MainLine {
    group_number;
    route_number;
    route_name;
    route_type = SIMARouteType.MAIN_LINE;
    _points;
    constructor(route, surveyPoints) {
        this.group_number = route.groupNumber;
        this.route_number = route.routeNumber;
        this.route_name = route.routeName;
        this._points = [];
        this._computeRoute(route, surveyPoints);
    }
    setSurveyPoints(surveyPoints) {
        this._points = surveyPoints;
    }
    get points() {
        return this._points;
    }
    _computeRoute(route, surveyPoints) {
        for (let i = 0; i < route.routeElements.length; i++) {
            const routeElement = route.routeElements[i];
            switch (routeElement.classifier) {
                case SIMAElementClassifier.ROUTE_COORD:
                    {
                        const rc = routeElement;
                        const point = surveyPoints.get(`${rc.point_number}-${rc.point_name}`);
                        if (point) {
                            this._points.push(point);
                        }
                    }
                    break;
                case SIMAElementClassifier.SIMPLE_CURVE:
                    {
                        const sc = routeElement;
                        const prevPoint = getPrevRouteCoord(route.routeElements, i, surveyPoints);
                        const nextPoint = getNextRouteCoord(route.routeElements, i, surveyPoints);
                        if (prevPoint && nextPoint) {
                            const arcPoints = interpolateSimpleCurve(sc, prevPoint, nextPoint);
                            this._points.push(...arcPoints);
                        }
                    }
                    break;
                default:
                    break;
            }
        }
    }
}
//# sourceMappingURL=main-line.js.map